import { Observable } from 'rxjs';
import { GroupsApi, PagedGroups } from 'src/app/hickory-api';
import { groupData } from './data/GroupData';
import { mockHandler } from '../mock.handler';

export class MockGroupsApi extends GroupsApi {

  getGroupsV21(groupIds?: Array<number>, importedGroupIds?: Array<string>, page?: number, pageSize?: number, search?: string): Observable<any> {
    const paged: PagedGroups = groupData.getPage(groupIds, page, pageSize, search);
    return mockHandler(paged);
  }

  getGroupsByIdV21(id: number, chatEnabledOnly?: boolean): Observable<any> {
    const item: PagedGroups = groupData.get(id);
    return mockHandler(item);
  }

  getSubgroupsByParentId(id: number, page?: number, pageSize?: number)
    : Observable<any> {
    const paged: PagedGroups = groupData.getSubgroups(id, page, pageSize);
    return mockHandler(paged);
  }

  getContactsByGroupId(id: number, chatEnabledOnly?: boolean, page?: number, pageSize?: number): Observable<any> {
    const paged: PagedGroups = groupData.getGroupContacts(id, chatEnabledOnly, page, pageSize);
    return mockHandler(paged);
  }
}
